import {
  Button,
  Flex,
  Text,
  Box,
  Tabs,
  Heading,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { BsClock } from "react-icons/bs";
import { BiShare } from "react-icons/bi";
import { AiOutlineCheckCircle } from "react-icons/ai";

export default function Packages() {
  return (
    <Box my={4}>
      <Tabs
        variant="unstyled"
        sx={{ border: "1px solid gray" }}
        borderRadius={10}
        overflow="hidden"
      >
        <TabList>
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="white"
            w="full"
            border="1px solid gray"
            borderLeft={0}
            borderTop={0}
          >
            Basic
          </Tab>
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="white"
            w="full"
            border="1px solid gray"
            borderLeft={0}
            borderTop={0}
          >
            Standard
          </Tab>
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="white"
            w="full"
            border="1px solid gray"
            borderLeft={0}
            borderTop={0}
            borderRight={0}
          >
            {" "}
            Premium
          </Tab>
        </TabList>
        <TabPanels>
          {packagesData.map((item,index) => {
            return (
              <TabPanel p={0} key={index}>
                <PackageBox {...item} />
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </Box>
  );
}
const PackageBox = ({ packageName, title, delivery, benefits, price }) => {
  return (
    <Stack>
      <Flex bg="#f7f7f7" justifyContent="space-between" p={4}  alignItems="center">
        <Text fontWeight="medium" fontSize="22px" color="black">{packageName}</Text>
        <Text color="brand.400" fontWeight="semibold" fontSize="28px">US${price}</Text>
      </Flex>
      <Box p={4}>
        <Heading
          fontSize={{ base: "16px", sm: "21px" }}
          fontWeight={"medium"}
          maxWidth={{ base: "90%" }}
          pb={6}
        
        >
          {title}
        </Heading>
        <Flex justifyContent="space-around" py={4} fontSize={{ base: "12px", md: "18px" }}>
          <Stack alignItems="center" >
            <Box
              borderRadius={"50px"}
            //   fontSize={{ base: "12px", md: "18px" }}
              p={{ base: 2, md: 3 }}
              color="white"
              bg="brand.400"
            >
              <BsClock />
            </Box>
            <Text fontWeight={"medium"}>{delivery} Day Delivery</Text>
          </Stack>
          <Stack alignItems="center">
            <Box
              borderRadius={"50px"}
            //   fontSize={{ base: "10px", md: "16px" }}
              p={{ base: 2, md: 3 }}
              color="white"
              bg="brand.400"
            >
              <BiShare />
            </Box>
            <Text fontWeight={"medium"} align="center">Unlimited Revisions</Text>
          </Stack>
        </Flex>
        <Stack gap={2} py={4}>
          {benefits?.map((item) => {
            return (
              <Flex color="brand.400" key={item} alignItems="center" gap={2} >
                <AiOutlineCheckCircle />
                <Text color="#858585" fontWeight={"semibold"}>
                  {item}
                </Text>
              </Flex>
            );
          })}
        </Stack>
        <Button
          bg="brand.500"
          w="full"
          py={6}
          my={4}
          borderRadius={10}
          fontWeight="medium"
          fontSize="18px"
          color="white"
          _hover={{ bg: "brand.400", color: "white" }}
        >
          Order now
        </Button>
      </Box>
    </Stack>
  );
};
const packagesData = [
  {
    packageName: "Gold Package",
    title: "2 HQ LOGO (300)DPI JPEG, PNG Unlimited Revsions",
    price: 20,
    delivery: 1,
    benefits: ["2 Concepts Included", "Print Files", "3D Mockup"],
  },
  {
    packageName: "Pro Package",
    title: "4 HQ LOGO (300)DPI JPEG, PNG Unlimited Revsions",
    price: 20,
    delivery: 1,
    benefits: ["4 Concepts Included", "Print Files", "3D Mockup"],
  },
  {
    packageName: "Premium Package",
    title: "6 HQ LOGO (300)DPI JPEG, PNG Unlimited Revsions",
    price: 20,
    delivery: 1,
    benefits: ["6 Concepts Included", "Print Files", "3D Mockup"],
  },
];
